import Request from '@/api/request';
import { ICreateStatementResponse, IStatement } from '@/types/services';
import { CommonObject } from '@/utils/types';

interface IFormPackagePayload {
  statementId: string;
  xmlSigBase64: string;
}

interface IFormPackageResponse {
  fileLink: string;
}

export interface IsArchiveFormedResponseSuccess {
  formed: boolean;
}

export interface IsArchiveFormedResponseError {
  errorString: string;
}

// Редактирование копии заявления, доп. документы
const api = new Request('lk/edited/statement/');

export function createEditedStatement(
  data: IStatement
): Promise<ICreateStatementResponse> {
  return api.post('create', data);
}

export function createEditedStatementXml(
  originalStatementId: string
): Promise<object> {
  return api.get(`statementXml?statementId=${originalStatementId}`);
}

export function editedStatementXmlBase64(
  originalStatementId: string
): Promise<string> {
  return api.get(`statementXmlBase64?statementId=${originalStatementId}`);
}

export function getEditedStatementInfo(
  originalStatementId: string
): Promise<IStatement> {
  return api.get(`statementInfo/?statementId=${originalStatementId}`);
}

export function getEditedStatementInfoToShow(
  originalStatementId: string
): Promise<CommonObject> {
  return api.get(`statementInfoToShow/?statementId=${originalStatementId}`);
}

export function editedFormPackage(
  payload: IFormPackagePayload
): Promise<IFormPackageResponse> {
  return api.post('formPackage', payload);
}

export function checkEditedIsArchiveFormed(
  originalStatementId: string
): Promise<IsArchiveFormedResponseSuccess | IsArchiveFormedResponseError> {
  return api.get(`isArchiveFormed?statementId=${originalStatementId}`);
}

export function deleteResendToFsspAddStmnt(
  originalStatementId: string
): Promise<any> {
  return api.delete(
    `resendToFsspAddStmnt?statementId=${originalStatementId}`
  );
}

export function deleteRejectedFolderAltAddStmt(
    originalStatementId: string
): Promise<any> {
  return api.delete(
      `rejectedFolderAltAddStmt?statementId=${originalStatementId}`
  );
}
